export default "__VITE_PUBLIC_ASSET__055a689d__"